// src/components/PureMadnessBanner.jsx
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../services/firebase";
import "../styles/PureMadnessBanner.css";

const PureMadnessBanner = () => {
    // Default fallback values
    const [banner, setBanner] = useState({
        image: 'https://placehold.co/1920x800',
        eyebrow: 'The Premium Collection',
        title: 'Pure Madness',
        subtitle: '100% Unprocessed Raw Hair. Pure in every strand.'
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchBanner = async () => {
            try {
                const ref = doc(db, "site_config", "home_content");
                const snap = await getDoc(ref);
                if (snap.exists() && snap.data().bannerData) {
                    const data = snap.data().bannerData;
                    setBanner({
                        image: data.image || 'https://placehold.co/1920x800',
                        eyebrow: data.eyebrow || 'The Premium Collection',
                        title: data.title || 'Pure Madness',
                        subtitle: data.subtitle || '100% Unprocessed Raw Hair. Pure in every strand.'
                    });
                }
            } catch (error) {
                console.error("Error fetching banner:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchBanner();
    }, []);

    // Don't render until we know the image so it doesn't flicker
    if (loading) return null;

    return (
        <section
            className="pure-madness-banner"
            style={{ backgroundImage: `url(${banner.image})` }} // Injects the live image URL
        >
            <div className="pure-madness-overlay">
                <div className="banner-content">
                    <span className="banner-eyebrow">{banner.eyebrow}</span>
                    <h2 className="banner-title">{banner.title}</h2>
                    <p className="banner-subtitle">{banner.subtitle}</p>
                    <Link to="/pure-madness" className="btn-luxury">
                        <span>Shop Raw Hair</span>
                    </Link>
                </div>
            </div>
        </section>
    );
};

export default PureMadnessBanner;